<form (ngSubmit)="onSuccessAdd()" [formGroup]="form">
    <div class="dialog-headline" fxLayout="row wrap" fxLayoutAlign="space-between center">
        <h2 mat-dialog-title translate>add_produit</h2>
        <button mat-dialog-close mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div mat-dialog-content>
        <div class="pc" fxLayout="row wrap">
            <div fxFlex.gt-sm="100" fxFlex.lt-md="100">
                <app-text-field
                        [control]="getFormControl('cateId')"
                        [label]="' Code de la classification des produits'"
                ></app-text-field>
            </div>
            <div fxFlex.gt-sm="100" fxFlex.lt-md="100">
                <app-text-field
                        [control]="getFormControl('name')"
                        [label]="'Nom de la classification des produits'"
                ></app-text-field>
            </div>

            <div fxFlex.gt-sm="100" fxFlex.lt-md="100">

                <app-select-produit-root
                    #rooract
                    (object)="sendfromroot($event)"
                    [control]="getFormControl('racine')"
                    [id]="'root'"
                    [label]="'produit_niveau0'"
                >
                </app-select-produit-root>

            </div>
            <div fxFlex.gt-sm="100" fxFlex.lt-md="100">

                <app-select-produit-root
                    #rootprod
                    (object)="send($event)"
                    [control]="getFormControl('root')"
                    [id]="root"
                    [label]="'produit_niveau1'"
                >
                </app-select-produit-root>
            </div>
            <div *ngIf="idfils1" fxFlex.gt-sm="100" fxFlex.lt-md="100">
                <app-select-produit-root
                    #fils1
                    (object)="sendfils($event)"
                    [control]="getFormControl('fils1')"
                    [id]="idfils1"
                    [label]="'produit_niveau2'"
                >
                </app-select-produit-root>
            </div>
            <div *ngIf="idfils2" fxFlex.gt-sm="100" fxFlex.lt-md="100">
                <app-select-produit-root
                    #fils2
                    (object)="sendfils2($event)"
                    [control]="getFormControl('fils2')"
                    [id]="idfils2"
                    [label]="'produit_niveau3'"
                >
                </app-select-produit-root>
            </div>

            <div fxFlex.gt-sm="100" fxFlex.lt-md="100">

                <section class="example-section">
                    <label id="example-radio-group-label">Fabricant ou revendeur:</label>
                    <mat-radio-group formControlName="makeFl">
                        <mat-radio-button class="example-margin" value="N">{{
                            " Revendeur" | translate
                            }}</mat-radio-button>
                        <mat-radio-button class="example-margin" value="Y"
                        >{{ "Fabricant" | translate }}
                        </mat-radio-button>
                    </mat-radio-group>
                </section>
            </div>


        </div>


    </div>
    <div class="pc" fxLayoutAlign="end end" mat-dialog-actions>
        <div fxLayout="row wrap" fxLayoutAlign="center center">
            <button [disabled]="form.invalid" color="primary" mat-raised-button type="submit">
                {{ "submit" | translate }}
            </button>
        </div>
    </div>
</form>

